var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavProyectosActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1463 0.547493C12.7734 0.231553 12.2266 0.231553 11.8537 0.547492L2.08137 8.82519C1.37075 9.42713 1.79642 10.5882 2.72772 10.5882H3.75V19C3.75 19.5523 4.19771 20 4.75 20H20.25C20.8023 20 21.25 19.5523 21.25 19V10.5882H22.2723C23.2036 10.5882 23.6293 9.42713 22.9186 8.82519L13.1463 0.547493ZM12.5 7.05882C13.4946 7.05882 14.4484 7.43067 15.1517 8.09256C15.8549 8.75446 16.25 9.65218 16.25 10.5882V10.7647C16.25 11.317 16.6977 11.7647 17.25 11.7647H17.5V16.4706H7.5V11.7647H7.75C8.30228 11.7647 8.75 11.317 8.75 10.7647V10.5882C8.75 9.65218 9.14509 8.75446 9.84835 8.09256C10.5516 7.43067 11.5054 7.05882 12.5 7.05882ZM12.5 9.41177C12.1685 9.41177 11.8505 9.53571 11.6161 9.75634C11.3817 9.97698 11.25 10.2762 11.25 10.5882V11.7647H13.75V10.5882C13.75 10 13.25 9.41177 12.5 9.41177Z",
    fill: "#7000FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProyectosActive);
export default __webpack_public_path__ + "static/media/nav-proyectos-active.92778e484b4cb6e6fa5026f73e3dcb33.svg";
export { ForwardRef as ReactComponent };